export const messages = {
  en: {
    commonReportTable: {
      queryConditions: 'Query Conditions',
      query: 'Query',
      reset: 'Reset',
      export: 'Export',
      print: 'Print',
      noData: 'No Data'
    }
  },
  zh: {
    commonReportTable: {
      queryConditions: '查询条件',
      query: '查询',
      reset: '重置',
      export: '导出',
      print: '打印',
      noData: '暂无数据'
    }
  },
  'zh-TW': {
    commonReportTable: {
      queryConditions: '查詢條件',
      query: '查詢',
      reset: '重置',
      export: '匯出',
      print: '列印',
      noData: '暫無數據'
    }
  }
}